import { Alert, Box } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

export type DuplicatePatientIdAlertProps = {
    id: string;
};

export function DuplicatePatientIdAlert({ id }: DuplicatePatientIdAlertProps) {
    const translate = getSelectedLanguage();

    return (
        <Box
            pb={6}
            px={6}
        >
            <Alert
                appearance="warning"
                noMargin={true}
            >
                {translate.patient.duplicateSocialSecuritySearchBar}
                <Alert.Link
                    to={`/patients/${id}`}
                    variant="link"
                >
                    {translate.patient.patient.toLowerCase()}
                </Alert.Link>
            </Alert>
        </Box>
    );
}
